import { formatTrackingDate } from './trackingHelpers';

// Conversion history is not a wallet balance and never changes current-PO money.
export function refundDepositPresentation(refund) {
  if (!refund || refund.status === 'DIBATALKAN') return null;
  const state = refund.deposit_conversion_state;
  const decision = typeof refund.decision === 'string' ? refund.decision.trim().toUpperCase() : ''; 
  const related = refund.status === 'JADI_DEPOSIT' || decision === 'DEPOSIT' ||
    state === 'completed' || state === 'pending' || state === 'unavailable';
  if (!related) return null;
  const amount = refund.deposit_conversion_amount;
  const kind = refund.deposit_conversion_kind;
  const completed = state === 'completed' && refund.status === 'JADI_DEPOSIT' &&
    decision === 'DEPOSIT' && (kind === 'overpayment' || kind === 'dp_return') &&
    Number.isSafeInteger(amount) && amount > 0 &&
    typeof refund.deposit_conversion_date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(refund.deposit_conversion_date) &&
    formatTrackingDate(refund.deposit_conversion_date) !== 'Belum tercatat';
  if (completed) return {
    completed: true, amount, amountLabel: kind === 'overpayment' ? 'Kelebihan pembayaran' : 'Nominal yang dijadikan deposit',
    status: { label: 'Jadi deposit', tone: 'green' },
    message: 'Sudah dijadikan deposit untuk PO berikutnya',
    date: refund.deposit_conversion_date,
  };
  if (state === 'pending' && refund.status !== 'JADI_DEPOSIT') return {
    completed: false, status: { label: 'Menunggu konversi deposit', tone: 'amber' },
    message: 'Menunggu konfirmasi untuk dijadikan deposit PO berikutnya.',
  };
  return {
    completed: false, status: { label: 'Status deposit belum terverifikasi', tone: 'amber' },
    message: 'Konversi deposit belum dapat dipastikan.',
  };
}
